import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  studentOnly?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false, studentOnly = false }) => {
  const { isAuthenticated, isAdmin, isStudent, user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // console.log('PrivateRoute state:', { 
    //   isAuthenticated, 
    //   isAdmin, 
    //   isStudent, 
    //   user, 
    //   path: location.pathname,
    //   adminOnly,
    //   studentOnly
    // });
  }, [isAuthenticated, isAdmin, isStudent, user, location.pathname, adminOnly, studentOnly]);

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    console.log('Admin route but not admin, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  if (studentOnly && !isStudent) {
    console.log('Student route but not student, redirecting to admin analytics');
    return <Navigate to="/admin/analytics" replace />;
  }

  // Check if student account is approved
  if (isStudent && user?.status !== 'approved') {
    console.log('Student account not approved');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <div>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              Account Pending Approval
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              ບັນຊີຂອງທ່ານກຳລັງລໍຖ້າການອະນຸມັດຂອງຜູ້ບໍລິຫານ. ກະລຸນາກວດສອບກັບມາໃນພາຍຫຼັງ.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // console.log('Access granted to route:', location.pathname);
  return <>{children}</>;
};

export default PrivateRoute; 